import React from "react";
import { LuLoader } from "react-icons/lu";

interface SpinnerProps {
    color?: string;
    size?: number;
    /** 画面（ビューポート）中央に置くか */
    centered?: boolean;
    /** オーバーレイで背面操作をブロックするか */
    blockInteraction?: boolean;
    /** メッセージ（任意） */
    message?: string;
    /** 垂直方向の配置: "center" | number(px) */
    y?: "center" | number;
}

export const Spinner = ({
                            color = "#4d2fbc",
                            size = 64,
                            centered = true,
                            blockInteraction = false,
                            message,
                            y = "center",
                        }: SpinnerProps = {}) => {
    const spinnerEl = (
        <div className="spinner-content">
            <LuLoader className="spinner-icon" color={color} size={size} />
            {message && (
                <div className="spinner-message">{message}</div>
            )}
        </div>
    );

    if (!centered) {
        return spinnerEl;
    }

    const overlayClass =
        "spinner-overlay" +
        (blockInteraction ? " spinner-overlay--blocking" : " spinner-overlay--passthrough");

    if (y === "center") {
        return (
            <div
                className={overlayClass + " spinner-overlay--center"}
                aria-busy="true"
                aria-live="polite"
            >
                <div
                    className={
                        "spinner-box" +
                        (blockInteraction ? "" : " spinner-overlay--blocking")
                    }
                >
                    {spinnerEl}
                </div>
                {blockInteraction && <div className="spinner-backdrop" />}
            </div>
        );
    }

    return (
        <div className={overlayClass} aria-busy="true" aria-live="polite">
            <div
                className="spinner-anchor"
                style={{ top: typeof y === "number" ? y : 0 }}
            >
                <div
                    className={
                        "spinner-box" +
                        (blockInteraction ? "" : " spinner-overlay--blocking")
                    }
                >
                    {spinnerEl}
                </div>
            </div>
            {blockInteraction && <div className="spinner-backdrop" />}
        </div>
    );
};
